module.exports = __webpack_public_path__ + "static/group2.313360cd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/group2.jpg
// module id = 531
// module chunks = 35783957827783